import Vue from 'vue';
export default class CookiesStorage {
    static keys = {
        USERNAME: 'username',
        SESSION_PASSWORD: 'sessionPassword',
        API_USER_FULL_NAME: 'apiUserFullName',
        API_USER_ID: 'apiUserId',
        API_USER_ROLE: 'apiUserRole',
        ADMIN_USERNAME: 'admin_username',
        ADMIN_SESSION_PASSWORD: 'admin_sessionPassword',
        ADMIN_API_USER_FULL_NAME: 'admin_apiUserFullName',
        ADMIN_PERMISSIONS: 'admin_permissions',
        IN_COMPANY: 'in_company',
        PLATFORM: 'platform'
    };
    static storeData(key, value, expires) {
        return Vue.$cookies.set(key, value, expires);
    }
    static loadData(key) {
        return Vue.$cookies.get(key);
    }
    static removeData(key) {
        return Vue.$cookies.remove(key);
    }
    static exists(key) {
        return Vue.$cookies.isKey(key);
    }
}
